// extracted by mini-css-extract-plugin
export default {"navigation":"Header_navigation__JDWvk","content":"Header_content__ca+jF","logo":"Header_logo__p3bQs"};